import { reactive } from 'vue'
import { Constants } from './defines/Constants'
import { Language } from './defines/Language'
import { Language as LanguagePak } from './defines/Language_pak'
import { AudioDefine } from './defines/AudioDefine'
import { DataKeyDefine } from './defines/DataKeyDefine'
import { EventDefine } from './defines/EventDefine'
import { SimpleEventEmitter } from './utils/functions'
import { MsgIDs } from './defines/MsgIDs'
import { UpdateModule } from './modules/UpdateModule'
import { ConfigModule } from './modules/ConfigModule'
import { UserModule } from './modules/UserModule'
import { LoginModule } from './modules/LoginModule'
import { CustomerModule } from './modules/CustomerModule'
import { ChannelModule } from './modules/ChannelModule'
import { SignModule } from './modules/SignModule'
import { HallModule } from './modules/HallModule'
import { VipModule } from './modules/VipModule'
import { VipDailyCashModule } from './modules/VipDailyCashModule'
import { AddCashModule } from './modules/AddCashModule'
import { VipEquityModule } from './modules/VipEquityModule'
import { ShareModule } from './modules/ShareModule'
import { WalletModule } from './modules/WalletModule'
import { TransactionModule } from './modules/TransactionModule'
import { MailModule } from './modules/MailModule'
import { PopupViewModule } from './modules/PopupViewModule'
import { RolloverModule } from './modules/RolloverModule'
import { FaceBookModule } from './modules/FaceBookModule'
import { EggCapsuleModule } from './modules/EggCapsuleModule'
import { WelcomeGiftModule } from './modules/WelcomeGiftModule'
import { BindActivityModule } from './modules/BindActivityModule'
import { TurnTableModule } from './modules/TurnTableModule'
import { RankModule } from './modules/RankModule'
import { PinDuoModule } from './modules/PinDuoModule'
import { RegisterModule } from './modules/RegisterModule'
import { BonanzaModule } from './modules/BonanzaModule'
import { WaterWheelModule } from './modules/WaterWheelModule'
import { FreeSpinModule } from './modules/FreeSpinModule'
import { DailyTaskModule } from './modules/DailyTaskModule'
import { MysticaBoxModule } from './modules/MysticaBoxModule'
import { MarqueeModule } from './modules/MarqueeModule'
import { JackpotGamsModule } from './modules/JackpotGamsModule'
import { WebSocketClient } from './net/WebSocketClient'

export class hall {
  // defines
  static Constants = Constants
  static AudioDefine = AudioDefine

  static DataKeyDefine = DataKeyDefine
  static EventDefine = EventDefine

  // events
  static eventDispatcher = new SimpleEventEmitter()

  // network
  static s2c = {}

  static MsgIDs: typeof MsgIDs = MsgIDs

  // modules
  static userModule = new UserModule()
  static configModule = new ConfigModule()
  static popupViewModule = new PopupViewModule()
  static updateModule = new UpdateModule()
  static loginModule = new LoginModule()
  static hallModule = new HallModule()
  static customerModule = new CustomerModule()
  static channelModule = new ChannelModule()
  static signModule = new SignModule()
  static vipModule = new VipModule()
  static vipDailyCashModule = new VipDailyCashModule()
  static addCashModule = new AddCashModule()
  static vipEquityModule = new VipEquityModule()
  static shareModule = new ShareModule()
  static walletModule = new WalletModule()
  static transactionModule = new TransactionModule()
  static mailModule = new MailModule()
  static rolloverModule = new RolloverModule()
  static faceBookModule = new FaceBookModule()
  static eggCapsuleModule = new EggCapsuleModule()
  static welcomeGiftModule = new WelcomeGiftModule()
  static bindActivityModule = new BindActivityModule()
  static turnTableModule = new TurnTableModule()
  static rankModule = new RankModule()
  static pinDuoModule = new PinDuoModule()
  static registerModule = new RegisterModule()
  static waterWheelModule = new WaterWheelModule()
  static bonanzaModule = new BonanzaModule()
  static freeSpinModule = new FreeSpinModule()
  static dailyTaskModule = new DailyTaskModule()
  static mysticaBoxModule = new MysticaBoxModule()
  static marqueeModule = new MarqueeModule()
  static jackpotGamsModule = new JackpotGamsModule()

  static moduleManager = [
    hall.userModule,
    hall.configModule,
    hall.popupViewModule,
    hall.updateModule,
    hall.loginModule,
    hall.hallModule,
    hall.customerModule,
    hall.channelModule,
    hall.signModule,
    hall.welcomeGiftModule,
    hall.vipModule,
    hall.vipDailyCashModule,
    hall.addCashModule,
    hall.vipEquityModule,
    hall.shareModule,
    hall.walletModule,
    hall.transactionModule,
    hall.mailModule,
    hall.rolloverModule,
    hall.faceBookModule,
    hall.eggCapsuleModule,
    hall.bindActivityModule,
    hall.turnTableModule,
    hall.rankModule,
    hall.pinDuoModule,
    hall.registerModule,
    hall.waterWheelModule,
    hall.bonanzaModule,
    hall.freeSpinModule,
    hall.dailyTaskModule,
    hall.mysticaBoxModule,
    hall.marqueeModule,
    hall.jackpotGamsModule,
  ]

  /**
   * Initializes all modules and registers their network handlers.
   */
  static init() {
    console.log('[Hall] Initializing modules...')
    
    // Load saved language or default based on country
    const savedLang = localStorage.getItem('user_language')
    if (savedLang) {
      hall.setLanguage(savedLang)
    } else if (hall.configModule.country === 1) { // Country.Pakistan = 1
      hall.setLanguage('pak')
    }

    for (const module of hall.moduleManager) {
      if (typeof (module as any).init === 'function') (module as any).init()
      if (typeof (module as any).inits2c === 'function') (module as any).inits2c()
      if (typeof (module as any).onLoad === 'function') (module as any).onLoad()
    }
    console.log('[Hall] All modules initialized.')
  }

  static network: any = null
  static Language: any = reactive({ ...Language })

  /**
   * Switches the global language and persists the choice.
   * @param langCode 'en' or 'pak'
   */
  static setLanguage(langCode: string) {
    console.log(`[Hall] Switching language to: ${langCode}`)
    let newLang = Language
    if (langCode === 'pak') {
      newLang = LanguagePak
    }

    // Update reactive Language object properties
    Object.assign(hall.Language, newLang)

    // Handle RTL for Urdu
    const root = document.documentElement
    if (langCode === 'pak') {
      root.setAttribute('dir', 'rtl')
      root.classList.add('lang-rtl')
    } else {
      root.setAttribute('dir', 'ltr')
      root.classList.remove('lang-rtl')
    }

    // Persist choice
    localStorage.setItem('user_language', langCode)

    // Notify components
    hall.eventDispatcher.emit(hall.EventDefine.LanguageChange, langCode)
  }
}
